import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=7a83ee7c"
import script from "./SidebarContent.js?vue&type=script&lang=js&external"
export * from "./SidebarContent.js?vue&type=script&lang=js&external"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=7a83ee7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports